import type React from 'react'

type FieldProps = Record<string, unknown>
type FieldRenderer = (props: FieldProps) => React.ReactNode

const isPlainFunctionComponent = (comp: React.ElementType): comp is FieldRenderer =>
  typeof comp === 'function' &&
  !(comp as { prototype?: { isReactComponent?: unknown } }).prototype?.isReactComponent

// Field configs are rebuilt on most renders, so a plain function component is a new element
// type each time and React would remount it. Invoking it here keeps the fiber keyed by the
// field name instead. Renderers call hooks unconditionally; a field that swaps renderers under
// one name keeps hooks out of the arrow (see packages/neo/AGENTS.md).
export const FieldMount = ({ Comp, props }: { Comp: React.ElementType; props: FieldProps }) =>
  isPlainFunctionComponent(Comp) ? <>{Comp(props)}</> : <Comp {...props} />
